// extracted by mini-css-extract-plugin
export default {"schoolName":"eOnK4dLaIII1fcunF4_s","icon":"n_xavAAkp0VdOB0AF2jd","grayWarning":"TK5GrEaN90AdSYarVtEi","location":"ypzZPjmINomaGY2rK9hQ","yellowWarning":"DF9zz69hLBkZjYZJm0AT"};